// L'endpoint MCP di authoring vive alla ROOT del backend (/mcp), non sotto la
// base REST /api/v1. Deriviamo quindi l'origin dall'URL della base API.
export function getMcpUrl(apiBaseUrl) {
  return `${new URL(apiBaseUrl).origin}/mcp`;
}

const SERVER_NAME = 'crafter-authoring';

// Genera gli snippet di configurazione per i principali client MCP.
// Gli schemi JSON sono verificati contro le doc ufficiali (2026-07):
// - Claude (Code/Desktop): { mcpServers: { <name>: { type: "http", url } } }
// - GitHub Copilot (VS Code mcp.json): { servers: { <name>: { type: "http", url } } }
// - OpenCode (opencode.json): { mcp: { <name>: { type: "remote", url, enabled: true } } }
export function buildSnippets(mcpUrl) {
  return {
    connectorUrl: mcpUrl,
    claudeCli: `claude mcp add --transport http ${SERVER_NAME} ${mcpUrl}`,
    claudeDesktop: JSON.stringify(
      { mcpServers: { [SERVER_NAME]: { type: 'http', url: mcpUrl } } },
      null,
      2,
    ),
    copilot: JSON.stringify(
      { servers: { [SERVER_NAME]: { type: 'http', url: mcpUrl } } },
      null,
      2,
    ),
    opencode: JSON.stringify(
      {
        $schema: 'https://opencode.ai/config.json',
        mcp: { [SERVER_NAME]: { type: 'remote', url: mcpUrl, enabled: true } },
      },
      null,
      2,
    ),
  };
}
